module.exports = __webpack_public_path__ + "img/icon.09ee4b3e.png";